import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'src/app/components/Button/Button';
import { IconContent } from 'src/app/components/Icon/IconContent';
import { IconKaskusForum } from 'src/app/components/Icon/IconKaskusForum';
import { IconUser } from 'src/app/components/Icon/IconUser';
import { FormattedCustomMessage } from 'src/app/components/Formatted/FormattedCustomMessage';
import { withStyles } from 'src/app/helpers/styles';

interface MyOwnProps {
  onClickLoginKaskus: VoidFunction;
  onClickLoginGuest: VoidFunction;
  isDarkMode?: boolean;
}

type MyProps = MyOwnProps;

@withStyles(require('./PopupJoinChat.scss'))
class MyClassPopupJoinChat extends React.Component<MyProps> {
  render(): JSX.Element {
    const { onClickLoginKaskus, onClickLoginGuest, isDarkMode } = this.props;
    const backgroundColor = isDarkMode ? 'bg-black' : 'bg-white';
    const foregroundColor = isDarkMode ? 'fg-white' : 'fg-black';

    const termOfServiceEl = <a href="https://bantuan.kaskus.co.id/hc/id/articles/226392548-Syarat-dan-Ketentuan" target="_blank">Syarat & Ketentuan</a>;
    const privacyPolicyEl = <a href="https://bantuan.kaskus.co.id/hc/id/articles/226293627-Kebijakan-Privasi" target="_blank">Kebijakan Privasi</a>;
    return (
      <div onClick={this.handlePopupClick} className={classnames('p-20 position-absolute popup-join-chat__container', backgroundColor)}>
        <div className={classnames('fs-16 fw-700 ls-2 ta-center mb-16', foregroundColor)}>
          <FormattedCustomMessage id={'popup.join.chat.title'} />
        </div>
        <div className={classnames('fs-16 ta-center mb-24', foregroundColor)}>
          <FormattedCustomMessage id={'popup.join.chat.message'} />
        </div>
        <div className="d-flex jc-center">
          <Button
            className={classnames('button--format-32 fw-700 b-1 w-100 fs-16 mb-16', foregroundColor)}
            modifier={isDarkMode ? 'black' : 'white'}
            onClick={onClickLoginKaskus}
          >
            <FormattedMessage id={'popup.join.chat.login'}>
              {(message) => <IconContent classNameIcon="fs-24 mr-14" icon={IconKaskusForum}>{message}</IconContent>}
            </FormattedMessage>
          </Button>
        </div>
        <div className="d-flex jc-center">
          <Button
            className={classnames('button--format-32 fw-700 b-1 w-100 fs-16 mb-16', foregroundColor)}
            modifier={isDarkMode ? 'black' : 'white'}
            onClick={onClickLoginGuest}
          >
            <FormattedMessage id={'popup.join.chat.guest'}>
              {(message) => <IconContent classNameIcon="fg-primary fs-20 mr-14 ml-4" icon={IconUser}>{message}</IconContent>}
            </FormattedMessage>
          </Button>
        </div>
        {
          !isDarkMode &&
          <div className={classnames('mt-8 fs-14', foregroundColor)}>
            <FormattedMessage id={'popup.join.chat.footer'} values={{ termOfService: termOfServiceEl, privacyPolicy: privacyPolicyEl }}/>
          </div>
        }
      </div>
    );
  }

  private handlePopupClick(e: React.MouseEvent<HTMLDivElement>): void {
    e.stopPropagation();
  }
}

export const PopupJoinChat = MyClassPopupJoinChat as React.ComponentClass<MyOwnProps>;
